import { useEffect, useState } from 'react'
import { Avatar, AvatarProps } from '@mui/material'
import { ProfileImageCacheService, ProfileImageType } from '@/services/profileImageCacheService'

interface ProfileImageAvatarProps extends Omit<AvatarProps, 'src'> {
  userId: string
  type: ProfileImageType
  fallbackSrc?: string
}

export const ProfileImageAvatar = ({ userId, type, fallbackSrc, ...avatarProps }: ProfileImageAvatarProps) => {
  const [imageSrc, setImageSrc] = useState<string | undefined>(fallbackSrc)

  useEffect(() => {
    let mounted = true
    let objectUrl: string | null = null

    const load = async () => {
      const blob = await ProfileImageCacheService.getImageBlob(userId, type)
      if (!mounted || !blob) {
        if (mounted) setImageSrc(fallbackSrc)
        return
      }

      objectUrl = URL.createObjectURL(blob)
      setImageSrc(objectUrl)
    }

    load()

    return () => {
      mounted = false
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [userId, type, fallbackSrc])

  return <Avatar src={imageSrc} {...avatarProps} />
}
